import { render } from "./RangeEffectControlVue.vue?vue&type=template&id=7b0b23d1&ts=true"
import script from "./RangeEffectControlVue.vue?vue&type=script&lang=ts"
export * from "./RangeEffectControlVue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__